const autoprefixer = require("autoprefixer")
const config = require("./config.json")

require("dotenv").config({
  path: ".env",
})

module.exports = {
  siteMetadata: {
    title: config.siteTitle,
    description: config.siteDescription,
    siteUrl: config.siteURL,
  },
  plugins: [
    {
      resolve: "gatsby-plugin-mailchimp",
      options: {
        endpoint: process.env.GATSBY_PLUGIN_MAILCHIMP_ADDRESS,
        timeout: 3500,
      },
    },
    {
      resolve: "gatsby-plugin-google-gtag",
      options: {
        trackingIds: ["G-7NRJ6NXY8Q"],
      },
    },
    {
      resolve: "gatsby-plugin-sass",
      options: {
        postCssPlugins: [autoprefixer({ grid: true })],
        precision: 8,
      },
    },
    "gatsby-plugin-react-helmet",
    "gatsby-plugin-sitemap",
    {
      resolve: "gatsby-plugin-react-svg",
      options: {
        rule: {
          include: /assets/,
        },
      },
    },
    {
      resolve: "gatsby-plugin-manifest",
      options: {
        name: config.siteTitle,
        short_name: config.siteTitle,
        start_url: "/",
        background_color: "#f7941e",
        theme_color: "#f7941e",
        display: "standalone",
        icon: "src/images/icon.png",
      },
    },
    {
      resolve: "gatsby-plugin-robots-txt",
      options: {
        host: config.siteURL,
        sitemap: `${config.siteURL}/blog/sitemap.xml`,
        resolveEnv: () => process.env.GATSBY_STAGE,
        env: {
          dev: {
            policy: [{ userAgent: "*", disallow: ["/"] }],
          },
          prod: {
            policy: [{ userAgent: "*", allow: "/" }],
          },
        },
      },
    },
    {
      resolve: "gatsby-plugin-facebook-pixel",
      options: {
        pixelId: process.env.GATSBY_PLUGIN_FACEBOOK_PIXEL,
      },
    },
    {
      resolve: "gatsby-plugin-twitter-pixel",
      options: {
        pixelId: process.env.GATSBY_PLUGIN_TWITTER_PIXEL,
      },
    },
    {
      resolve: "gatsby-plugin-feed",
      options: {
        query: `
          {
            site {
              siteMetadata {
                title
                description
                siteUrl
              }
            }
          }
        `,
        feeds: [
          {
            serialize: ({ query: { site, allDevArticles } }) => {
              return allDevArticles.edges.map((edge) => {
                return Object.assign({}, edge.node.article, {
                  description: edge.node.article.description,
                  date: edge.node.article.published_at,
                  url: edge.node.article.canonical_url,
                  guid: site.siteMetadata.siteUrl + "/blog/" + edge.node.article.slug,
                  custom_elements: [{ "content:encoded": edge.node.article.body_html }],
                })
              })
            },
            query: `
              {
                allDevArticles(sort: {order: DESC, fields: article___published_at}) {
                  edges {
                    node {
                      article {
                        slug
                        title
                        published_at
                        body_html
                        canonical_url
                        description
                      }
                    }
                  }
                }
              }
            `,
            output: "/rss.xml",
            title: `${config.siteTitle} RSS Feed`,
          },
        ],
      },
    },
  ],
  pathPrefix: "/blog",
}
